import { usePrevious } from '#src/hooks/usePrevious.ts'

export function useDidChange<T>(value: T): boolean {
  const previous = usePrevious(value)
  return previous !== value
}
